export default __webpack_public_path__ + "static/media/atlas-landscape.97adfda5.svg";